import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import qs from 'querystring'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    status: '',
    token: localStorage.getItem('token') || '',
    user : {},
    video: '',
  },
  mutations: {
    auth_request(state){
      state.status = 'loading'
      },
    auth_success(state, token, user){
      state.status = 'success'
      state.token = token
      state.user = user
    },
    auth_error(state){
      state.status = 'error'
    },
    logout(state){
      state.status = 'not_logged_in'
      state.token = ''
    },
    video_close(state){
      state.video = 'closed'
    },
    video_pause(state){
      state.video = 'paused'
    },
    video_play(state){
      state.video = 'playing'
    }
  },
  actions: {    
    login({commit}, datalogin){
      var formdata = new FormData();
      formdata.set('user', datalogin.user);
      formdata.set('password', datalogin.password);

      var data= qs.stringify({"user":datalogin.user,"password":datalogin.password})
      
      axios.defaults.headers =
            {
              'Content-Type': 'application/x-www-form-urlencoded',
            }

      return new Promise((resolve, reject) => {
      commit('auth_request')
      

      axios.post('https://www.lalabumapp.com:4443/Login',data)
        .then(resp => {
              const token = resp.data.data.token              
              localStorage.setItem('token', token)                            
              commit('auth_success', token, datalogin.user)
              resolve(resp)
              })
          .catch(err => {
              commit('auth_error')
              localStorage.removeItem('token')
              reject(err)
              })
          })
  },
    register({commit}, data){            
            return new Promise((resolve, reject) => { 
            commit('registering')                                  
            axios.post('https://www.lalabumapp.com:4443/Register',data)
                .then(resp => {
                    if(resp.status=="200"){
                      alert("Usuario creado exitosamente")
                    }
                    
                    resolve(resp)
                    })
                .catch(err => {
                    if(err.message=="Request failed with status code 421"){
                      alert("El usuario ya existe")
                    }
                    if(err.message=="Request failed with status code 423"){
                      alert("Esta licencia ya fue activada")
                    }
                    if(err.message=="Request failed with status code 500"){
                      alert("Licencia invalida")
                    }
                     reject(err)
                    })
            })
  },
    recovery({commit}, params){
      var formdata = new FormData();
      formdata.set('user', params.email);
      var data= qs.stringify({"user":params.email})

      axios.defaults.headers =
            {
              'Content-Type': 'application/x-www-form-urlencoded',
            }

      return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('https://www.lalabumapp.com:4443/ResetPasswordSendEmail',data)
        .then(resp => {
              if (resp.status == 200) {
                resolve(200)  
              }else{
                reject(500)
              }
              
            })
          .catch(() => {                            
              reject(500)
          })
      })
  },
  reset_password({commit}, params){
    var formdata = new FormData();
      formdata.set('password', params.pass);
      var data= qs.stringify({"password":params.pass})
      
      axios.defaults.headers =
            {
              'Content-Type': 'application/x-www-form-urlencoded',
              'Authorization': 'Bearer '+params.token
            }

      return new Promise((resolve, reject) => {
      commit('auth_request')
      axios.post('https://www.lalabumapp.com:4443/ResetPassword',data)
        .then(resp => {
              if (resp.status == 200) {
                resolve(200)  
              }else{
                reject(500)
              }
              
            })
          .catch(() => {                            
              reject(500)
          })
      })

  }
        
  },
  getters : {
      isLoggedIn: state => !!state.token,
      authStatus: state => state.status,
  }
})
